import React from "react";
import { Link } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import logo from "../../assets/images/logo.png";

export const AppFooter: React.FC = () => (
  <footer className="hidden sm:block bg-[#0f0d0d] border-t border-white/10 mt-auto">
    <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <img src={logo} alt="Crays" className="h-12 w-auto opacity-70" />
        <p className="text-offwhite/30 text-xs flex items-center gap-1">
          © {new Date().getFullYear()} Crays. Made with
          <FiHeart className="w-3 h-3 text-magenta inline" />
          in South Africa.
        </p>
      </div>
      <div className="flex items-center gap-4 flex-wrap justify-center">
        {[
          { label: "Privacy", to: "/privacy-policy" },
          { label: "Terms", to: "/terms-of-service" },
          { label: "Safety", to: "/safety" },
          { label: "Contact", to: "/contact-us" },
          { label: "About", to: "/about-us" },
        ].map(({ label, to }) => (
          <Link
            key={to}
            to={to}
            className="text-offwhite/35 hover:text-offwhite/70 text-xs transition-colors"
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  </footer>
);
